var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Instagram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7998 3.80469H8.39978C5.50029 3.80469 3.14978 6.1552 3.14978 9.05469V17.4547C3.14978 20.3542 5.50029 22.7047 8.39978 22.7047H16.7998C19.6992 22.7047 22.0498 20.3542 22.0498 17.4547V9.05469C22.0498 6.1552 19.6992 3.80469 16.7998 3.80469ZM20.2123 17.4547C20.2065 19.3369 18.682 20.8614 16.7998 20.8672H8.39978C6.5175 20.8614 4.99304 19.3369 4.98728 17.4547V9.05469C4.99304 7.1724 6.5175 5.64795 8.39978 5.64219H16.7998C18.682 5.64795 20.2065 7.1724 20.2123 9.05469V17.4547ZM17.5873 9.31719C18.1672 9.31719 18.6373 8.84708 18.6373 8.26719C18.6373 7.68729 18.1672 7.21719 17.5873 7.21719C17.0074 7.21719 16.5373 7.68729 16.5373 8.26719C16.5373 8.84708 17.0074 9.31719 17.5873 9.31719ZM12.5998 8.52969C9.99024 8.52969 7.87478 10.6451 7.87478 13.2547C7.87478 15.8643 9.99024 17.9797 12.5998 17.9797C15.2093 17.9797 17.3248 15.8643 17.3248 13.2547C17.3276 12.0007 16.8307 10.7972 15.9439 9.91052C15.0572 9.02381 13.8538 8.52689 12.5998 8.52969ZM9.71228 13.2547C9.71228 14.8494 11.005 16.1422 12.5998 16.1422C14.1945 16.1422 15.4873 14.8494 15.4873 13.2547C15.4873 11.6599 14.1945 10.3672 12.5998 10.3672C11.005 10.3672 9.71228 11.6599 9.71228 13.2547Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.67328208b9055048cb37eaad7c53c5c8.svg";
export { ForwardRef as ReactComponent };